<template>
  <!-- eslint-disable-next-line vue/no-unused-refs -->
 <base-list-management ref="baseListManagement" :configData.sync="configData">
  <PublicExport
      slot="custom-export"
      v-if="judgePermission('driver_customer_list_detail')"
      exportTitle="导出"
      exportTemplate="Tenant"
      :getSearchData="searchParams"
      templateCode="vehicle-workbench-rent-order"
      :getSearchCondition="getSearchCondition"
    />
 </base-list-management>
</template>
<script>
import diffConfigFn from './config'
import { CUSTOMER_TYPE } from '../../config'
import { PurchaseAndSeven, getPersonalOrders } from '@/api/purchaseAndSaleAPI'
import { generateExportCondition } from '@/utils/exportUtils.js'

const API_CONF = {
  [CUSTOMER_TYPE.PERSON]: getPersonalOrders,
  [CUSTOMER_TYPE.ENTERPRISE]: PurchaseAndSeven,
}

export default {
  name: 'order',
  data() {
    const { configData } = diffConfigFn.call(this, 'personalOrder')
    configData.tableData.apiFn = API_CONF[this.customerType]
    return {
      configData,
      // configData里有引用
      // eslint-disable-next-line vue/no-unused-properties
      carConditionList: [],
    }
  },
  props: ['customerId', 'customerType', 'customerData'],
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    dealWithData(params) {
      params.customerId = this.customerId
      params.customerType = Number(this.customerType)
    },
    searchParams() {
      return {
        ...this.$refs.baseListManagement?.getParams() || {},
        customerId: this.customerId,
      }
    },
    getSearchCondition() {
      const params = this.searchParams()
      // input和日期没有值时不展示，其他没有值时展示全部
      const conditions = []
      this.configData.formData.list.forEach((item) => {
        const {
          el,
          itemConfig: { label, prop: key },
        } = item
        const val = params[key]
        if (key === 'carId') {
          item.elConfig.options.list = this.carConditionList
        }
        if (el === 'CarBrandSeriesModel') {
          const brandSeriesItem = this.$refs.baseListManagement.getRefs({ type: 'form', formItemRef: 'brandSeriesModelRef' })
          const { brandSeries, model } = brandSeriesItem.getLabels()
          conditions.push(brandSeries)
          conditions.push(model)
        } else {
          const { matchValue, hidden } = generateExportCondition[el](val, item)
          conditions.push({
            label,
            key,
            matchValue,
            hidden,
          })
        }
      })
      conditions.push({
        label: '客户名称',
        key: 'customerId',
        matchValue: this.customerData.customerName,
        hidden: false,
      })
      return conditions
    },
  },
}
</script>
